import React, { Component } from "react";
import { Icon, Button,  InputGroup, Callout  } from "@blueprintjs/core";
import { validate } from "validate.js";
import { Translate, I18n } from "react-redux-i18n";
import LoadingIndicator from "../LoadingIndicator";
 
class  UsageLogForm extends Component {     
    state={
        expense_form:{
            value: "",
            unit: "km",
            description: ""
        },
        validation_errors: {},
    }
   
    updateFields=(event)=>{    
        this.setState({
            expense_form:{
                ...this.state.expense_form,
                [event.target.id]: event.target.value
            }
        });         
    }   

    submitForm=(e)=>{
        e.preventDefault(); 
        
        const validationErrors = validate(
            this.state.expense_form,
            this.props.validators
        );
      
        this.setState({
          validation_errors: validationErrors ? validationErrors : {}
        });        

        if (!validationErrors) {
          this.props.onSave(this.state.expense_form);
          this.setState({expense_form:{value: "", description: ""}});
        }
    } 

    render(){
        const hrs= I18n.t("new_usage_log.options.hrs")
        const min= I18n.t("new_usage_log.options.min")
        const km= I18n.t("new_usage_log.options.km")
        return(
            <>  
                <form onSubmit={this.submitForm}>
                    {(this.state.validation_errors.value || this.state.validation_errors.description) &&
                        <div className="form-error-message">
                            <Callout intent="danger" icon="error">       
                                {this.state.validation_errors.value?
                                    <Translate
                                        value={this.state.validation_errors.value[0]}
                                    />
                                :
                                    null
                                }      
                                {this.state.validation_errors.description?
                                    <Translate
                                        value={this.state.validation_errors.description[0]}
                                    />
                                :
                                    null
                                }
                            </Callout>
                        <div className="spacer-16" />
                    </div>
                    }

                    <div className={
                        this.state.validation_errors.name
                        ? "form-group error inline-split no-bottom-margin usage-logs"
                        : "form-group inline-split no-bottom-margin usage-logs"
                        }
                    >
                        <div className="bp5-select split-item">
                            <select id="unit" className="bp3-input" onChange={this.updateFields}>
                                <option value="km" defaultValue>{km}</option>
                                <option value="hrs">{hrs}</option>
                                <option value="min">{min}</option>
                            </select>
                        </div>

                        <InputGroup
                            id="value"
                            type="number"
                            value={this.state.expense_form.value}
                            placeholder={I18n.t("new_usage_log.placeholders.value")}  
                            fill={true}
                            onChange={this.updateFields}
                            className="split-item no-icon third"
                        />

                        <InputGroup
                            id="description"
                            type="text"
                            value={this.state.expense_form.description}
                            placeholder={I18n.t("new_usage_log.placeholders.description")}   
                            fill={true}
                            onChange={this.updateFields}
                            className="split-item no-icon has-button primary-button two-thirds"
                            rightElement={
                                this.props.loading?
                                <LoadingIndicator />:       
                                <Button className="input-button right" type="submit">
                                    <Icon icon="add" iconSize="24" className="icon" />
                                </Button>
                            }
                        />
                    </div>       
                </form>               
            </>
        )
    }
}

export default UsageLogForm;